import { generatePath } from "react-router-dom";
import { AppRoutes } from "../../routes/routeConstants/appRoutes";

function safeListPath(pathname: string): string {
  if (!pathname || !pathname.startsWith("/") || pathname.startsWith("//")) {
    return AppRoutes.CASES;
  }
  return pathname;
}

/**
 * Current LMS page path + query (for filters) to restore when the user clicks
 * "Cases" in the embedded viewer toolbar.
 */
export function getViewerListReturnQuery(): {
  viewerListPath: string;
  viewerListSearch?: string;
} {
  const viewerListPath = safeListPath(window.location.pathname);
  const q = window.location.search.startsWith("?")
    ? window.location.search.slice(1)
    : "";
  return q ? { viewerListPath, viewerListSearch: q } : { viewerListPath };
}

/**
 * Full URL to open the case viewer (new tab), including viewerListPath / viewerListSearch
 * so the viewer can navigate back to this listing with the same filters.
 */
export function buildCaseDetailViewerUrl(
  caseId: number | string,
  opts?: { seriesIdCsv?: string }
): string {
  const base = `${window.location.origin}${generatePath(AppRoutes.CASE_DETAIL, {
    caseId: String(caseId),
  })}`;
  const sp = new URLSearchParams();
  if (opts?.seriesIdCsv) {
    sp.set("seriesId", opts.seriesIdCsv);
  }
  const ret = getViewerListReturnQuery();
  sp.set("viewerListPath", ret.viewerListPath);
  if (ret.viewerListSearch) {
    sp.set("viewerListSearch", ret.viewerListSearch);
  }
  return `${base}?${sp.toString()}`;
}
